import * as actionTypes from "./actionTypes";

const initialState = {
  isLoading: false,
  hasDuplicatedMarks: false,
  assistanceData: [],
  employeeList: [],
  openCalendarList: [],
  mapData: [],
  schedules: [],
  locale: "es",
  dateFormat: "yyyy/mm/dd",
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_ASSISTANCE_ROWS:
      return { ...state, isLoading: true };
    case actionTypes.GET_ASSISTANCE_ROWS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        hasDuplicatedMarks: action.payload.hasDuplicatedMarks,
        dateFormat: action.payload.dateFormat,
        assistanceData: action.payload.assistanceData,
        employeeList: action.payload.employeeList,
        openCalendarList: action.payload.openCalendarList,
      };
    case actionTypes.GET_ASSISTANCE_ROWS_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CREATE_ASSISTANCE_MARK:
      return { ...state, isLoading: true };
    case actionTypes.CREATE_ASSISTANCE_MARK_FULFILLED:
      return {
        ...state,
        isLoading: false,
        hasDuplicatedMarks: action.payload.hasDuplicatedMarks,
        assistanceData: action.payload.assistanceData,
        employeeList: action.payload.employeeList,
        openCalendarList: action.payload.openCalendarList,
      };
    case actionTypes.CREATE_ASSISTANCE_MARK_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.UPDATE_ASSISTANCE_MARK:
      return { ...state, isLoading: true };
    case actionTypes.UPDATE_ASSISTANCE_MARK_FULFILLED:
      return {
        ...state,
        isLoading: false,
        hasDuplicatedMarks: action.payload.hasDuplicatedMarks,
        assistanceData: action.payload.assistanceData,
        employeeList: action.payload.employeeList,
        openCalendarList: action.payload.openCalendarList,
      };
    case actionTypes.UPDATE_ASSISTANCE_MARK_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DELETE_ASSISTANCE_MARK:
      return { ...state, isLoading: true };
    case actionTypes.DELETE_ASSISTANCE_MARK_FULFILLED:
      return {
        ...state,
        isLoading: false,
        hasDuplicatedMarks: action.payload.hasDuplicatedMarks,
        assistanceData: action.payload.assistanceData,
      };
    case actionTypes.DELETE_ASSISTANCE_MARK_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_MAP_DATA:
      return { ...state, isLoading: true };
    case actionTypes.GET_MAP_DATA_FULFILLED:
      return {
        ...state,
        isLoading: false,
        mapData: action.payload.data,
      };
    case actionTypes.GET_MAP_DATA_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_CHANGE_SCHEDULE:
      return { ...state, isLoading: true };
    case actionTypes.GET_CHANGE_SCHEDULE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        schedules: action.payload.schedules,
      };
    case actionTypes.GET_CHANGE_SCHEDULE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.UPDATE_SCHEDULE:
      return { ...state, isLoading: true };
    case actionTypes.UPDATE_SCHEDULE_FULFILLED:
      return { ...state, isLoading: false };
    case actionTypes.UPDATE_SCHEDULE_REJECTED:
      return { ...state, isLoading: false };
    default:
      return state;
  }
}
